import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { firebasePlugin } from './firebasePlugin';
import store from './store';
import './registerServiceWorker'
import './assets/tailwind.css'

const app = createApp(App);

app.use(store);
app.use(firebasePlugin);
app.use(router);


app.mount('#app');
